import {DeliverState} from './deliverables/state'
import {ProjectOverviewState} from './ProjectsOverview/state'
const CombineState = () => {
  return {
    deliverableInfo:DeliverState(),
    ProjectOverviewInfo:ProjectOverviewState()
  }
}

export default CombineState